









































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Projet} from '@/models';

import CrudProjetFilter from '@/components/Crud/Projet/Filter.vue';
import CrudProjetEditDialog from '@/components/Crud/Projet/EditDialog.vue';
import CrudProjetList from '@/components/Crud/Projet/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeProjet, {ProjetFilter} from '@/stores/modules/projet';

@Component({
	components: {
		CrudProjetFilter,
		CrudProjetEditDialog,
		CrudProjetList,
		CrudDeleteDialog,
	}
})
export default class ProjetView extends Vue {

	@Stored(() => storeProjet) private projets!: ResultType<Projet>;
	@Stored(() => storeProjet) private filters!: ProjetFilter;

	private imgPath: string = "";

	private editProjet: Projet = null;
	private deletedProjet: Projet = null;
	private storeProjet = storeProjet;
	private list;

	public mounted() {
		this.list = this.$refs['list'] as CrudProjetList
	}

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editProjet = new Projet();
		this.refresh();
	}

	private refresh(): void {
		storeProjet.dispatch('getC', { filters: true });
	}
}
